import { render, staticRenderFns } from "./PendingResponseModal.vue?vue&type=template&id=5a2f9a54&scoped=true&"
import script from "./PendingResponseModal.vue?vue&type=script&lang=js&"
export * from "./PendingResponseModal.vue?vue&type=script&lang=js&"
import style0 from "./PendingResponseModal.vue?vue&type=style&index=0&id=5a2f9a54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2f9a54",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox, CFlex: require('@chakra-ui/vue').CFlex})
